"use client";

import { useSubDistricts } from "@entities/common";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import type { Ninja_Sub_Districts } from "@sisnaker-react-core/karirhub-model-type";
import { Combobox, type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { useState } from "react";

interface SubDistrictComboboxProps {
  initialValue?: ComboboxOption | null;
  onChange: (value: ComboboxOption) => void;
  onClear?: () => void;
  disabled?: boolean;
  cityIds?: string[];
}

export const SubDistrictCombobox = ({ initialValue, onChange, onClear, disabled, cityIds }: SubDistrictComboboxProps) => {
  const [keyword, setKeyword] = useState<string>("");
  const { subDistricts, isLoading } = useSubDistricts({ keyword, cityIds, enabled: !disabled, page: 1, limit: 5 });

  const options: ComboboxOption[] = subDistricts.map((sub_district: Ninja_Sub_Districts) => ({
    value: sub_district.id,
    label: sub_district.name,
  }));

  return (
    <Combobox
      options={options}
      initialValue={initialValue}
      onChange={onChange}
      clearable
      searchable
      placeholder="Pilih kecamatan"
      searchPlaceholder="Cari kecamatan..."
      fallbackText={isLoading ? "Memuat..." : "Tidak ada data"}
      onSearch={(keyword) => setKeyword(keyword)}
      onClear={onClear}
      buttonProps={{
        disabled,
        className: "w-full",
      }}
      inputProps={{
        className: "w-full",
      }}
      appendIcon={<ChevronUpDownIcon className="size-5" />}
    />
  );
};
